export default "__VITE_ASSET__Cc9F6Dc9__"